import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { GetCasesQuery, GetCasesResponse } from "./cases.types";
import CasesApi from "@/api/cases";

const QueryKeys = {
  all: ["cases", "list"],
  list: (q: GetCasesQuery) => ["cases", "list", q],
};

export type UseGetCases = (
  q: GetCasesQuery,
  options?: Omit<
    UseQueryOptions<GetCasesResponse, Error>,
    "queryKey" | "queryFn"
  >
) => UseQueryResult<GetCasesResponse, Error>;

const useGetCases: UseGetCases = (q, options) => {
  return useQuery({
    queryKey: QueryKeys.list({ ...q, data_only: false }),
    queryFn: () => CasesApi.getCases({ ...q, data_only: false }),
    ...options,
  });
};

export const CasesQuery = {
  useGetCases,
};
